// Payload is polymorphic across every action in the app; a generic default
// is required so subclasses without a payload stay ergonomic.
// `any` permitted under constitution v1.1.0 Principle I (inline justification).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export abstract class StoreAction<T = any> {
  static readonly type: string = '';

  constructor(public payload?: T) {}
}
